import * as React from 'react';
import { Box } from '@mui/material';
import { HiChevronRight } from 'react-icons/hi';
import { useLocation, useNavigate } from 'react-router-dom';
// Render labels with links and an icon delimiter
export default function BreadcrumSimpleChevron({
	items,
}: {
	items: {
		label: string;
		href: string;
	}[];
}) {
	const location = useLocation();
	const navigate = useNavigate();

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				gap: 1,
				fontSize: 'sm',
				fontWeight: 500,
				color: 'gray.500',
				mb: 2,
			}}
		>
			{items.map((item, index) => {
				return (
					<Box
						component="a"
						href={item.href}
						key={index}
						onClick={(e) => {
							e.preventDefault();
							navigate(item.href);
						}}
						sx={{
							color: location.pathname.includes(item.href)
								? 'black'
								: 'grey.500',
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							gap: 1,
							textDecoration: 'none',
							cursor: 'pointer',
						}}
					>
						{item.label}
						{index !== items.length - 1 && <HiChevronRight />}
					</Box>
				);
			})}
		</Box>
	);
}
